var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.87 20.63v3.27c0 1.22.63 1.47 1.4.53l3.1-3.77h10a4.22 4.22 0 0 0 4.13-4.22v-.34h-8a5.2 5.2 0 0 1-5.13-5.18v-6.3H4.15A4.14 4.14 0 0 0 0 8.75v7.7c0 2.2 1.74 4.04 3.87 4.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.05 0h-14.6c-.78 0-1.53.3-2.08.86a3 3 0 0 0-.87 2.1V11a2.99 2.99 0 0 0 2.95 3.02h8.89l4.08 4.93c.78.93 1.4.7 1.4-.52l-.01-4.41h.24A2.99 2.99 0 0 0 32 10.99V2.97a3 3 0 0 0-.87-2.1A2.91 2.91 0 0 0 29.05 0Z"
  })));
};
export default SvgSms;